import { render, staticRenderFns } from "./AddressesComponent.vue?vue&type=template&id=093be38b"
import script from "./AddressesComponent.vue?vue&type=script&lang=js"
export * from "./AddressesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports